
import { PAGE_TYPE, QUERY_BLOG_DETAIL } from "./-index.query";
import { seoMixin, pageMixin } from "~/mixins";

export default {
  mixins: [seoMixin, pageMixin],

  async asyncData({ app, params: { handle }, error }) {
    const [{ data: blogData }, { [PAGE_TYPE]: data }] = await Promise.all([
      app.$search.blogSearch({ query: handle, pageSize: 1 }),
      app.$prismicGql.request({
        query: QUERY_BLOG_DETAIL,
        variables: { uid: handle },
      }),
    ]);

    if (!data) {
      return error({ statusCode: 404, message: "Page not found" });
    }

    const blog = {
      ...data,
      next_blog: blogData.results[0]?.next_blog,
      prev_blog: blogData.results[0]?.prev_blog,
    };

    return {
      blog,
      uid: handle,
      title: blog.title,
      pageType: PAGE_TYPE,
      metaTitle: blog.metaTitle,
      metaDescription: blog.metaDescription,
      metaRobots: blog.metaRobots,
      metaFields: { _linkType: blog._linkType, _meta: blog._meta },
    };
  },

  computed: {
    imgAlt() {
      return this.blog.feature_image.alt ?? this.$prismic.asText(this.title);
    },
    imgProps() {
      return {
        src: this.blog.feature_image.url,
        alt: this.imgAlt,
        width: this.blog.feature_image.dimensions?.width,
        height: this.blog.feature_image.dimensions?.height,
        fit: "cover",
        sizes: "md:100vw lg:100vw xl:1400px",
        modifiers: { aspectRatio: "4:1" },
      };
    },
  },
};
